/** The three phases, in the order a day runs through them. */
export const PHASES = ['morning', 'midday', 'exec_sync'];
/** When each phase nominally starts, in minutes past midnight. */
const PHASE_START_MINUTES = {
    morning: 9 * 60,
    midday: 13 * 60,
    exec_sync: 16 * 60 + 30,
};
/** Minutes of cosmetic wall time one tick represents. */
const MINUTES_PER_TICK = 7;
/** The phase after `phase`, or `null` at the end of the day. */
export function nextPhase(phase) {
    const index = PHASES.indexOf(phase);
    return PHASES[index + 1] ?? null;
}
/**
 * The clock after an `ADVANCE_PHASE`. Advancing from the last phase rolls over
 * into the next day's morning; the tick counter restarts each phase.
 */
export function advanced(clock) {
    const following = nextPhase(clock.phase);
    return following === null
        ? { day: clock.day + 1, phase: 'morning', tick: 0, phasesUsed: clock.phasesUsed + 1 }
        : { day: clock.day, phase: following, tick: 0, phasesUsed: clock.phasesUsed + 1 };
}
/** The `HH:MM` shown beside a message posted at this point in the day. */
export function timestampFor(phase, tick) {
    const total = PHASE_START_MINUTES[phase] + tick * MINUTES_PER_TICK;
    const hours = Math.floor(total / 60) % 24;
    const minutes = total % 60;
    return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
}
//# sourceMappingURL=clock.js.map